<script>
export default {
  name: "MessageBase",
  data() {
    return {
      messages: [],
      removeCount: 0,
    };
  },
  methods: {
    messageClass(type) {
      switch (type) {
        case "error":
          return "alert-danger";
        case "warning":
          return "alert-warning";
        case "info":
          return "alert-info";
        case "success":
          return "alert-success";
        default:
          return "alert-secondary";
      }
    },
    addMessage(message) {
      message.rand_id = Math.floor(Math.random() * 1000000000);
      this.messages.push(message);
      setTimeout(this.removeMessage, 5000);
    },
    removeMessage() {
      this.messages.shift();
    },
  },
};
</script>
<template>
  <div class="mhi-message">
    <transition-group name="list" tag="div" class="wrapper">
      <div
        :class="['alert message py-2 my-1', messageClass(message.type)]"
        role="alert"
        v-for="message in messages"
        :key="message.rand_id"
      >
        {{ message.text }}
      </div>
    </transition-group>
  </div>
</template>
